import "./bootstrap";
import { createApp, watch } from "vue";
import App from "./App.vue";
import vuetify from "../plugins/vuetify";
import router from "../router";
import VueApexCharts from "vue3-apexcharts";
import i18n from '../plugins/i18n';
import { createPinia } from 'pinia';

import { loadAppConfig } from '../config/globalProperties';
import { guardarPedidoDeVolta } from '../services/api/apps.js';

// Antes do router: e ele quem vai descartar a query na primeira navegacao, e o
// pedido de volta precisa sobreviver ao login inteiro (segundo fator, escolha
// de empresa) para ser cumprido no fim.
guardarPedidoDeVolta();

const app = createApp(App);

loadAppConfig(app).then(() => {
    app.use(router).use(vuetify).use(i18n).use(createPinia()).use(VueApexCharts);
    app.mount("#app");
});
